<template>
  <main class="main page-inside">
    <div class="first-section-container">
      <img src="../images/Paimnet2.png" class="bg" />
      <div class="section first-section">
        <div class="wrapper">
          <div class="title payment-title">{{ $t("PAYMENT DETAILS") }}</div>
          <div class="form">
            <div class="form-row">
              <div class="form-column">
                <label>
                  <span class="title-tiny">{{ $t("FIRST NAME:") }}</span>
                  <input
                    type="text"
                    v-model="name"
                    :placeholder="$t('First Name')"
                  />
                </label>
                <label>
                  <span class="title-tiny">{{ $t("EMAIL:") }}</span>
                  <input type="email" v-model="email" :placeholder="$t('Email')" />
                </label>
                <label>
                  <span class="title-tiny">{{ $t("ADDRESS:") }}</span>
                  <input
                    type="text"
                    v-model="address"
                    :placeholder="$t('Address')"
                  />
                </label>
                <label>
                  <span class="title-tiny">{{ $t("COUNTRY:") }}</span>
                  <select v-model="country">
                    <option value="" disabled>{{ $t("Country") }}</option>
                    <option
                      v-for="item in countryOptions"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.title }}
                    </option>
                  </select>
                </label>
              </div>
              <div class="form-column">
                <label>
                  <span class="title-tiny">{{ $t("LAST NAME:") }}</span>
                  <input
                    type="text"
                    v-model="surname"
                    :placeholder="$t('Last Name')"
                  />
                </label>
                <label>
                  <span class="title-tiny">{{ $t("PHONE:") }}</span>
                  <input type="text" v-model="phone" :placeholder="$t('Phone')" />
                </label>
                <label>
                  <span class="title-tiny">{{ $t("CITY:") }}</span>
                  <input type="text" v-model="city" :placeholder="$t('City')" />
                </label>
                <label>
                  <span class="title-tiny">{{ $t("ZIP-CODE:") }}</span>
                  <input
                    type="text"
                    v-model="postCode"
                    :placeholder="$t('ZIP-CODE')"
                  />
                </label>
              </div>
            </div>
            <label>
              <span class="title-tiny">{{ $t("AMOUNT:") }}</span>
              <input type="number" min="1" v-model.number="amount" />
            </label>

            <div v-if="paymentMethods.length" class="topup-methods">
              <div class="topup-methods__list">
                <button
                  v-for="method in availablePaymentMethods"
                  :key="method.code"
                  type="button"
                  :class="['button black topup-method-btn', { active: selectedPaymentMethod === method.code }]"
                  @click="selectedPaymentMethod = method.code"
                >
                  <img v-if="method.image" :src="method.image" :alt="method.title || method.code" />
                  <span v-else>{{ method.title || method.code }}</span>
                </button>
              </div>
            </div>

            <div class="chekbox-container">
              <label class="chekbox-label">
                <div class="chekbox-label-wrapper">
                  <input v-model="termsAccepted" type="checkbox" name="terms" />
                  <div class="checkbox" />
                  <span class="desc">{{ $t("I agree with") }} </span>
                  <a
                    class="desc orange"
                    @click.prevent="$parent.goToPage('privacy')"
                    >{{ $t("privacy policy") }}</a
                  >
                  <span class="desc"> {{ $t("and") }} </span>
                  <a class="desc orange" @click.prevent="$parent.goToPage('terms')">{{
                    $t("terms and conditions")
                  }}</a>
                </div>
              </label>
            </div>
            <div class="form-actions">
              <div
                :class="[
                  'button next-button',
                  { disabled: !requiredFieldsAreFilled || loading },
                ]"
                @click="submit"
              >
                {{ loading ? $t("PROCESSING...") : $t("NEXT") }}
              </div>
            </div>
            <transition name="fade">
              <div class="desc error" v-if="error || $parent.error">
                {{ error || $parent.error }}
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "TopUp",
  props: [],
  data() {
    return {
      countryOptions: [],
      name: "",
      surname: "",
      phone: "",
      email: "",
      address: "",
      city: "",
      country: "",
      postCode: "",
      amount: 5,
      termsAccepted: false,
      loading: false,
      error: "",
      initialized: false,
      selectedPaymentMethod: "",
    };
  },
  computed: {
    parentIsAuth() {
      return this.$parent && this.$parent.isAuth;
    },
    requiredFieldsAreFilled() {
      const minTopup = Number(this.$parent?.settings?.min_topup_amount || 1);
      return !!(
        this.name &&
        this.surname &&
        this.phone &&
        this.email &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode &&
        this.termsAccepted &&
        Number(this.amount) >= minTopup
      );
    },
    paymentMethods() {
      const methods = this.$parent?.settings?.payment_methods;
      return Array.isArray(methods) ? methods : [];
    },
    availablePaymentMethods() {
      const currentCurrency = this.$parent?.currencyCode || this.$parent?.currency || '';
      return this.paymentMethods.filter((method) => {
        if (!Array.isArray(method.currencies) || !method.currencies.length) return true;
        return method.currencies.includes(currentCurrency);
      });
    },
    selectedPaymentMethodObject() {
      return this.availablePaymentMethods.find((m) => m.code === this.selectedPaymentMethod) || null;
    },
  },
  watch: {
    parentIsAuth(value) {
      if (value) {
        this.initializePage();
      }
    },
    availablePaymentMethods(methods) {
      if (!methods.length) {
        this.selectedPaymentMethod = "";
        return;
      }
      const exists = methods.some((m) => m.code === this.selectedPaymentMethod);
      if (!exists) {
        this.selectedPaymentMethod = methods[0].code;
      }
    },
  },
  mounted() {
    const amountFromQuery = Number(this.$route.query.amount || 5);
    this.amount = amountFromQuery > 0 ? amountFromQuery : 5;
    this.initializePage();
  },
  methods: {
    async initializePage() {
      if (this.initialized) return;
      if (!this.parentIsAuth) {
        await this.$parent.openSignInModal();
        if (!this.parentIsAuth) return;
      }
      this.initialized = true;
      if (!this.selectedPaymentMethod && this.availablePaymentMethods.length) {
        this.selectedPaymentMethod = this.availablePaymentMethods[0].code;
      }
      this.getCountries();
    },
    getCountries() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload || [];
        })
        .catch(() => {});
    },
    async submit() {
      if (!this.requiredFieldsAreFilled || this.loading) return;

      this.loading = true;
      this.error = "";
      this.$parent.error = "";

      const data = {
        first_name: this.name,
        last_name: this.surname,
        phone: this.phone,
        email: this.email,
        country_id: this.country,
        city: this.city,
        address: this.address,
        zip: this.postCode,
        amount: this.amount,
        paymentType: this.selectedPaymentMethod || (this.availablePaymentMethods[0]?.code || "card"),
      };

      try {
        await this.$parent.topUp(data);
      } catch (err) {
        this.error = err.message || this.$t("Payment failed");
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.topup-methods {
  margin-top: 12px;
}

.topup-methods__list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.topup-method-btn {
  min-width: 150px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
}

.topup-method-btn img {
  max-height: 20px;
  width: auto;
}

.topup-method-btn.active {
  border-color: #9d1712;
}

</style>
